import React, { useEffect } from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import ResizeListener from "../../../../utility/ResizeListener";
import BodyComponent from "../../../components/BodyComponent";
import TopHeaderComponent from "../../../components/TopHeaderComponent";
import { WHITE_COLOR } from "../../../resources/colorsManager";
import BasicDetails from "./BasicDetails";
import OtherDetails from "./OtherDetails";
import CustomerTransaction from "../display_customer/Transactions";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import { SUCCESS } from "../../../resources/constantsManager";
function DisplayCustomer() {
  const { width, height } = ResizeListener();
  const [step, setStep] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const [bankDetails, setBankDetails] = useState([]);
  const pStyle = {
    fontSize: 14,
    fontWeight: "bold",
    fontFamily: "Roboto",
    cursor: "pointer",
  };

  const getAllBankDetails = () => {
    ApiRequestGet.getCustomerBankDetails({
      customerHashId: location?.state?.customerDetails?.customerHashId,
    })
      .then((response) => {
        if (response.status === SUCCESS) {
          setBankDetails(response.data);
        }
      })
      .catch((error) => {});
  };
  useEffect(() => {
    getAllBankDetails();
  }, [location]);
  return (
    <BodyComponent style={{ width: "100%" }}>
      <TopHeaderComponent
        headerName={
          location?.state?.customerDetails?.firstName +
          " " +
          location?.state?.customerDetails?.lastName
        }
        isSearchRequired={false}
        inputStyle={{
          width: width * 0.3,
          minWidth: 300,
        }}
        placeholder="Search Transaction ID...."
        onClickBack={() => {
          // navigate("/customers");
          navigate(-1);
        }}
        showFilter={false}
        showDownload={false}
        isOnClickBack={true}
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          backgroundColor: WHITE_COLOR,
          marginTop: 20,
          borderRadius: 15,
          flexDirection: "column",
          height: width > 1000 ? "auto" : "100%",
        }}
      >
        <div
          style={{
            width: "100%",
            padding: 10,
            borderBottom: "1px solid #C4C4C4",
          }}
        >
          <div
            style={{
              display: "flex",
              minWidth: 300,
              maxWidth: 450,
              justifyContent: "space-between",
              marginLeft: 20,
            }}
          >
            <p
              style={{
                ...pStyle,
                color: step === 0 ? "black" : "#8F8F8F",
              }}
              onClick={() => setStep(0)}
            >
              Basic Details
            </p>
            <p
              style={{
                ...pStyle,
                color: step === 1 ? "black" : "#8F8F8F",
              }}
              onClick={() => setStep(1)}
            >
              Other Details
            </p>
            <p
              style={{
                ...pStyle,
                color: step === 2 ? "black" : "#8F8F8F",
              }}
              onClick={() => setStep(2)}
            >
              Transactions
            </p>
          </div>
        </div>

        <div
          style={{
            width: "100%",
            padding: "20px 0px",
            maxHeight: height * 0.55,
            overflow: "auto",
          }}
        >
          {step === 0 ? (
            <BasicDetails details={location?.state?.customerDetails} />
          ) : step === 1 ? (
            <OtherDetails
              bankDetails={bankDetails}
              customerHashId={location?.state?.customerDetails?.customerHashId}
              onSuccess={() => {
                getAllBankDetails();
              }}
            />
          ) : step === 2 ? (
            <CustomerTransaction details={location?.state?.customerDetails} />
          ) : null}
        </div>
      </div>
    </BodyComponent>
  );
}

export default DisplayCustomer;
